import React from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import styled from "styled-components";
import HeroSlide1 from "./HeroSlide1";
import HeroSlide2 from "./HeroSlide2";
import { DARK_KUBBE } from "../../../constants/Colors";

const SliderWrapper = styled.section`
  border-radius: 30px;
  overflow: hidden;
  box-shadow: 10px 10px 20px ${DARK_KUBBE}80;
  margin: auto;
  @media (max-width: 768px) {
    box-shadow: 0px 0px 0px;
    border-radius: 0px;
  }
`;

const StyledSlider = styled(Slider)`
  .slick-dots {
    margin-bottom: 40px; /* ajustá esto según lo que necesites */
  }
  .slick-list {
    overflow: hidden;
  }
  .slick-slide > div {
    padding: 0px;
  }

  .slick-dots li button:before {
    color: #fff;
    font-size: 12px;
  }
  @media (max-width: 768px) {
    .slick-slide > div {
      padding: 0px 1px;
    }
  }
`;

const HeroSection = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 700,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 5000,
  };

  return (
    <SliderWrapper>
      <StyledSlider {...settings}>
        <HeroSlide1 />
        <HeroSlide2 />
      </StyledSlider>
    </SliderWrapper>
  );
};

export default HeroSection;
